import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { disconnectRealtimeHub } from "./Services/apiService";
import { getStoredLangCode, setStoredLangCode } from "./utils/language";

const SessionExpiredModal = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleSessionExpired = () => {
      disconnectRealtimeHub();
      setOpen(true);
    };

    window.addEventListener("sessionExpired", handleSessionExpired);

    return () => {
      window.removeEventListener("sessionExpired", handleSessionExpired);
    };
  }, []);

  const handleLogin = () => {
    const language = getStoredLangCode();
    setOpen(false);
    localStorage.clear();
    sessionStorage.removeItem("hasModalShown");
    setStoredLangCode(language);
    window.location.href = "/SignIn";
  };

  if (!open) return null;

  return (
    <div
      className="modal fade show postAdd"
      data-modal-no-escape="true"
      tabIndex="-1"
      role="dialog"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content d-flex justify-content-around p-2">
          <div className="modalBorder d-flex justify-content-between align-items-center p-2">
            <h6>{t("modals.Session expired title", "You have been logged out")}</h6>
          </div>
          <p className="f-14 p-3">
            {t(
              "modals.Session expired body",
              "We noticed that you aren't active in the session, so we logged you out for your safety. Please click on the button to log in again."
            )}
          </p>

          <div className="text-start mt-2 ps-3">
            <button type="button" className="mainBtn" onClick={handleLogin}>
              {t("SignIn.Sign in")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
